module.exports = "/_next/static/images/Security-md@2x-01ee008d7f5ea03fb75f78fba4ebd071.webp";